<template>

	<div class="portlet box green" v-if="classLevel === 'Bercario' || classLevel === 'Infantil'">

		<div class="portlet-title">

			<div class="caption">
				<i class="fa fa-bed" aria-hidden="true"></i>
				<span v-translate>Soneca</span>
			</div>

		</div>

		<div class="portlet-body">

			<form v-on:submit.prevent="addNapItem" class="row" role="form">

				<div class="form-group col-md-4 col-xs-6" :class="{ 'has-error': errors.has('nap-starttime') }">

					<label class="control-label" for="nap-starttime" v-translate>Horário de Início</label>
					<input type="text" v-mask="'##:##'" placeholder="Exemplo: 16:00" id="nap-starttime" name="nap-starttime" class="form-control" @change="completionStatus(false)" v-model="nap.startTime" v-validate="{ rules: { required: true, regex: /([01]\d|2[0-3]):([0-5]\d)/} }">

				</div>

				<div class="form-group col-md-4 col-xs-6" :class="{ 'has-error': errors.has('nap-endtime') }">

					<label class="control-label" for="nap-endtime" v-translate>Horário de Final</label>
					<input type="text" v-mask="'##:##'" placeholder="Exemplo: 16:30" id="nap-endtime" name="nap-endtime" class="form-control" @change="completionStatus(false)" v-model="nap.endTime" v-validate="{ rules: { required: true, regex: /([01]\d|2[0-3]):([0-5]\d)/} }">

				</div>

				<div class="form-group col-md-3 col-xs-12 col-md-offset-1">

					<button type="submit" class="btn btn-block btn-add-nap-item green" :disabled="errors.items.length > 0">
						<span v-translate>Adicionar</span>
					</button>

				</div>

			</form>

			<div class="table-responsive" v-if="naps && naps.length > 0">

				<table class="table table-bordered table-striped table-hover m-b-0">

					<thead>
						<tr>
							<th v-translate>Horário de Início</th>
							<th v-translate>Horário de Fim</th>
							<th v-translate>Ações</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="(nap, index) in naps">
							<td>{{ nap.startTime | date('HH:mm', true) }}</td>
							<td>{{ nap.endTime | date('HH:mm', true) }}</td>
							<td>

								<button type="button" class="btn btn-info btn-xs" @click="editNapsItem(index)">
									<i class="fa fa-pencil" aria-hidden="true"></i>
								</button>

								<button type="button" class="btn btn-danger btn-xs" @click="deleteNapItem(index)">
									<i class="fa fa-times" aria-hidden="true"></i>
								</button>

							</td>
						</tr>
					</tbody>

				</table>

			</div>

		</div>

	</div>

</template>

<script>

	import StudentNap from './';
	export default StudentNap;

</script>

<style lang="scss" scoped>

	table {
		margin-bottom: 0;
	}

	.btn-add-nap-item {
		margin-top: 25px;
	}

</style>



// WEBPACK FOOTER //
// main.vue?6412cf41